// src/components/exams/index.js - Главный роутер
import React, { useState, useEffect } from 'react';
import ExamManagement from './ExamManagement';
import TestManagement from './TestManagement';
import QuestionsList from './QuestionBank/QuestionsList';
import QuestionForm from './QuestionEditor/QuestionForm';
import { questionBank as initialQuestionBank, initialExams } from './data';
import { getExams } from "../../services/Exams/ExamsService";
const ExamSystem = () => {
  // Состояние данных
  const [exams, setExams] = useState([]);
  const [questionBank, setQuestionBank] = useState(initialQuestionBank);
  
  // Состояние навигации
  const [currentModule, setCurrentModule] = useState('exams'); // 'exams' | 'tests' | 'questions'
  const [currentMode, setCurrentMode] = useState('list'); // 'list' | 'create' | 'edit'
  
  // Выбранные элементы
  const [selectedExam, setSelectedExam] = useState(null);
  const [selectedTest, setSelectedTest] = useState(null);
  const [selectedQuestion, setSelectedQuestion] = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    getExams({ signal: controller.signal })
      .then(data => setExams(data?.results || data)) // если пагинация
      .catch(err => console.error("Ошибка загрузки экзаменов:", err));
    return () => controller.abort();
  }, []);

  // === ЭКЗАМЕНЫ ===
  const handleCreateExam = (examData) => {
    const newExam = {
      id: Date.now(),
      ...examData,
      status: 'Черновик',
      createdAt: new Date().toISOString().split('T')[0],
      tests: []
    };
    setExams(prev => [...prev, newExam]);
  };

  const handleDeleteExam = (examId) => {
    setExams(prev => prev.filter(exam => exam.id !== examId));
  };

  const handleCreateTestForExam = (exam) => {
    setSelectedExam(exam);
    setCurrentModule('tests');
    setCurrentMode('create');
  };

  const handleEditTestForExam = (exam, test) => {
    setSelectedExam(exam);
    setSelectedTest(test);
    setCurrentModule('tests');
    setCurrentMode('edit');
  };

  // === ТЕСТЫ ===
  const handleCreateTest = (testData) => {
    const newTest = {
      id: Date.now(),
      ...testData,
      questions: []
    };
    
    setExams(prev => prev.map(exam => 
      exam.id === selectedExam.id 
        ? { ...exam, tests: [...exam.tests, newTest] }
        : exam
    ));

    // Обновляем selectedExam
    setSelectedExam(prev => ({
      ...prev,
      tests: [...prev.tests, newTest]
    }));

    setCurrentModule('exams');
    setCurrentMode('list');
  };

  const handleAddQuestionToTest = (questionId) => {
    if (!selectedTest.questions.includes(questionId)) {
      const updatedTest = {
        ...selectedTest,
        questions: [...selectedTest.questions, questionId]
      };

      // Обновляем экзамены
      setExams(prev => prev.map(exam => 
        exam.id === selectedExam.id 
          ? {
              ...exam,
              tests: exam.tests.map(test => 
                test.id === selectedTest.id ? updatedTest : test
              )
            }
          : exam
      ));

      // Обновляем выбранный тест
      setSelectedTest(updatedTest);

      // Обновляем выбранный экзамен
      setSelectedExam(prev => ({
        ...prev,
        tests: prev.tests.map(test => 
          test.id === selectedTest.id ? updatedTest : test
        )
      }));
    }
  };

  const handleRemoveQuestionFromTest = (questionId) => {
    const updatedTest = {
      ...selectedTest,
      questions: selectedTest.questions.filter(id => id !== questionId)
    };

    setExams(prev => prev.map(exam => 
      exam.id === selectedExam.id 
        ? {
            ...exam,
            tests: exam.tests.map(test => 
              test.id === selectedTest.id ? updatedTest : test
            )
          }
        : exam
    ));

    setSelectedTest(updatedTest);
    setSelectedExam(prev => ({
      ...prev,
      tests: prev.tests.map(test => 
        test.id === selectedTest.id ? updatedTest : test
      )
    }));
  };

  // === ВОПРОСЫ ===
  const handleCreateQuestion = () => {
    setSelectedQuestion(null);
    setCurrentModule('questions');
    setCurrentMode('create');
  };

  const handleEditQuestion = (question) => {
    setSelectedQuestion(question);
    setCurrentModule('questions');
    setCurrentMode('edit');
  };

  const handleSaveQuestion = (questionData) => {
    if (selectedQuestion) {
      // Редактирование
      setQuestionBank(prev => prev.map(q => 
        q.id === selectedQuestion.id ? questionData : q
      ));
    } else {
      // Создание
      setQuestionBank(prev => [...prev, questionData]);
    }
    
    setCurrentModule('questions');
    setCurrentMode('list');
  };

  const handleDeleteQuestion = (questionId) => {
    setQuestionBank(prev => prev.filter(q => q.id !== questionId));
  };

  // === НАВИГАЦИЯ ===
  const handleBackToExams = () => {
    setCurrentModule('exams');
    setCurrentMode('list');
    setSelectedExam(null);
    setSelectedTest(null);
  };

  const handleBackToQuestions = () => {
    setCurrentModule('questions');
    setCurrentMode('list');
    setSelectedQuestion(null);
  };



  return (
    <div className="min-h-screen bg-gray-50">
      <ExamManagement
        exams={exams}
        questionBank={questionBank}
        onCreateExam={handleCreateExam}
        onDeleteExam={handleDeleteExam}
        onCreateTest={handleCreateTestForExam}
        onEditTest={handleEditTestForExam}
      />
    </div>
  );
};

export default ExamSystem;